import { render, staticRenderFns } from "./TicketDepiction.vue?vue&type=template&id=3197b449"
import script from "./TicketDepiction.vue?vue&type=script&lang=js"
export * from "./TicketDepiction.vue?vue&type=script&lang=js"
import style0 from "./TicketDepiction.vue?vue&type=style&index=0&id=3197b449&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports